@if (!appSettings.isMobile()) {
    <div class="row mb-3 align-items-end g-2">
        <div class="col-md-4">
            <label class="form-label small text-muted mb-1">Proceso</label>
            <ng-select
                [items]="processes()"
                bindLabel="name"
                bindValue="slug"
                placeholder="Todos los procesos"
                [clearable]="true"
                [ngModel]="processFilter()"
                (ngModelChange)="onFilterChange($event)">
            </ng-select>
        </div>
        <div class="col-md-8 d-flex justify-content-end gap-2">
            @if (processFilter()) {
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearFilter()">
                    <i class="fas fa-times me-1"></i> Limpiar filtro
                </button>
            }
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="load()" [disabled]="loading()">
                <i class="fas fa-sync-alt me-1" [class.fa-spin]="loading()"></i> Actualizar
            </button>
        </div>
    </div>

    <div class="table-responsive table-data mb-2">
        <table class="table table-hover table-sm align-middle">
            <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Proceso</th>
                    <th>Cambio</th>
                    <th>Quién</th>
                    <th class="text-center">Pasos</th>
                    <th class="text-center">Abiertas</th>
                    <th class="text-end">Acciones</th>
                </tr>
            </thead>
            <tbody>
                @if (loading()) {
                    @for (i of skeletonRows; track i) {
                        <tr>
                            @for (c of [1,2,3,4,5,6,7]; track c) {
                                <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                            }
                        </tr>
                    }
                } @else {
                    @for (row of rows(); track row.id) {
                        <tr app-flow-audit-row
                            [row]="row"
                            [busyId]="rollingBackId()"
                            (restore)="rollback($event)">
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="7" class="text-center text-muted py-5">
                                <i class="fas fa-history fa-2x mb-2 d-block opacity-50"></i>
                                No hay cambios registrados
                                @if (processFilter()) { para este proceso }.
                                <div class="small mt-2">
                                    Los registros aparecen al usar <strong>Guardar flujo</strong>.
                                </div>
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>

    <div class="d-flex justify-content-between align-items-center">
        <span class="small text-muted">{{ rangeLabel() }}</span>
        <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-secondary"
                (click)="prevPage()" [disabled]="!canPrev() || loading()">
                Anterior
            </button>
            <button type="button" class="btn btn-outline-secondary"
                (click)="nextPage()" [disabled]="!canNext() || loading()">
                Siguiente
            </button>
        </div>
    </div>
} @else {
    <app-mobile-footer>
        <ng-select
            class="mobile-footer-search"
            [items]="processes()"
            bindLabel="name"
            bindValue="slug"
            placeholder="Filtrar por proceso"
            [clearable]="true"
            [dropdownPosition]="'top'"
            [ngModel]="processFilter()"
            (ngModelChange)="onFilterChange($event)">
        </ng-select>
        @if (processFilter()) {
            <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
                (click)="clearFilter()">
                <i class="fas fa-times me-1"></i>Limpiar
            </button>
        }
    </app-mobile-footer>

    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            Historial @if (!loading()) { ({{ rangeLabel() }}) }
        </span>
        <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
            (click)="load()" [disabled]="loading()">
            <i class="fas fa-sync-alt" [class.fa-spin]="loading()"></i>
        </button>
    </div>

    <div class="mobile-cards-scroll">
        @if (loading()) {
            @for (i of skeletonRows; track i) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (row of rows(); track row.id) {
                <app-list-card>
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        {{ row.processName || row.processSlug }}
                    </div>
                    <div cardBadge>
                        <span class="badge border fw-normal" [ngClass]="badgeClass(row)">
                            {{ row.actionLabel }}
                        </span>
                    </div>

                    <div class="row g-1 text-muted small">
                        <div class="col-6">
                            <span class="text-muted">Fecha</span>
                            <div class="fw-semibold text-dark">{{ formatWhen(row.createdAt) }}</div>
                        </div>
                        <div class="col-6">
                            <span class="text-muted">Quién</span>
                            <div class="fw-semibold text-dark text-truncate">{{ actorLabel(row) }}</div>
                        </div>
                        <div class="col-6 mt-1">
                            <span class="text-muted">Pasos</span>
                            <div class="fw-semibold text-dark">{{ stepsLabel(row) }}</div>
                        </div>
                        <div class="col-6 mt-1">
                            <span class="text-muted">Abiertas</span>
                            <div class="fw-semibold text-dark">
                                @if (row.affectedCount > 0) {
                                    {{ row.affectedCount }}
                                } @else {
                                    —
                                }
                            </div>
                        </div>
                    </div>

                    @if (row.canRollback) {
                        <div cardActionsRow class="d-flex gap-2">
                            <button type="button"
                                class="btn btn-sm btn-outline-warning flex-fill"
                                [disabled]="anyBusy()"
                                (click)="rollback(row)">
                                @if (isBusy(row)) {
                                    <i class="fas fa-spinner fa-spin me-1"></i>
                                } @else {
                                    <i class="fas fa-undo me-1"></i>
                                }
                                Restaurar
                            </button>
                        </div>
                    }
                </app-list-card>
            }
        }

        @if (!loading() && rows().length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-history fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin cambios</h6>
                <small class="text-muted">
                    @if (processFilter()) {
                        No hay historial para este proceso.
                    } @else {
                        Los registros aparecen al guardar un flujo.
                    }
                </small>
            </div>
        }
    </div>

    @if (!loading() && rows().length > 0) {
        <div class="mobile-sticky-footer">
            <div class="d-flex justify-content-between align-items-center gap-2">
                <span class="small text-muted">{{ rangeLabel() }}</span>
                <div class="btn-group btn-group-sm">
                    <button type="button" class="btn btn-outline-secondary"
                        (click)="prevPage()" [disabled]="!canPrev() || loading()">
                        Ant.
                    </button>
                    <button type="button" class="btn btn-outline-secondary"
                        (click)="nextPage()" [disabled]="!canNext() || loading()">
                        Sig.
                    </button>
                </div>
            </div>
        </div>
    }
}
